
export const transition = {}